module.exports = __webpack_public_path__ + "static/media/ArrowUp.09c2e105.svg";